import CommentList from './CommentList';
import {Link} from 'react-router-dom';
import React from 'react';
import PostCommentComponent from "./PostCommentComponent";
import useTranslation from "../../customHooks/translations";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {DEFAULT_THEME_COLOR} from "../../constants/theme";
import {useMediaQuery} from "react-responsive";

const CommentContainer = props => {
  const translation = useTranslation();
  const isDesktop = useMediaQuery({ minWidth: 992 });
  const navHeight = isDesktop ? 58 : 98;

  return (
    <Box sx={{ mt: 2, pb: 16 }}>
      <CommentList
        comments={props.comments}
        slug={props.slug}
        currentUser={props.currentUser}
      />

      {/* FAB positioned above the bottom nav */}
      <Box
        sx={{
          position: 'fixed',
          bottom: navHeight,
          right: 16,
          zIndex: 10000,
        }}
      >
        {props.currentUser
          ? <PostCommentComponent slug={props.slug} text={translation.comments.postComment} fab />
          : (
            <Box
              sx={{
                background: 'linear-gradient(135deg, #0d1b2a 0%, #0d2a1e 100%)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: 2,
                p: 1.5,
                textAlign: 'center',
                maxWidth: 260,
              }}
            >
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.5)' }}>
                <Link to="/login" style={{ color: DEFAULT_THEME_COLOR, textDecoration: 'none', fontWeight: 600 }}>Sign in</Link>
                {' '}or{' '}
                <Link to="/register" style={{ color: DEFAULT_THEME_COLOR, textDecoration: 'none', fontWeight: 600 }}>sign up</Link>
                {' '}to add comments.
              </Typography>
            </Box>
          )
        }
      </Box>
    </Box>
  );
};

export default CommentContainer;
